import React from "react";
import styled from "styled-components";
import Callout, { containerStyles } from "../molecules/Callout";

const CalloutContainer = styled.div`
  margin: -20px -28px 0;
  padding: 10px 20px;
  & + & {
    margin-top: 0;
  }
`;

interface CalloutConfig {
  type: string;
  content: any;
}

interface IProps {
  calloutConfigs: CalloutConfig[];
}

// this components handles the styling and spacing so that a Callout can fit nicely inside a Dialog
const DialogCallout = ({ calloutConfigs }: IProps) => {
  return (
    <>
      {calloutConfigs.map((x, index) => (
        <CalloutContainer key={index} style={containerStyles[x.type]}>
          <Callout type={x.type}>{x.content}</Callout>
        </CalloutContainer>
      ))}
    </>
  );
};

export default DialogCallout;
